module.exports = __webpack_public_path__ + "static/media/DB3.421cef9c.mp4";